/**
 * Canvas Editor v2 — Personalizador de página completa (GigaPrint)
 * Sección: sections/canvas-editor-page.liquid · CSS: assets/canvas-editor.css
 *
 * Editor multi-elemento estilo "customizer": imágenes, textos y formas sobre el
 * área de impresión, con tipografías, colores, alineación, duplicar, reordenar
 * y eliminar. Reemplaza (ahora sí funcional) al customizer viejo:
 *
 *  1. Lee ?product_handle&variant_id(&pw&ph&bleed&safe) de la URL
 *  2. Hidrata el producto vía /products/{handle}.js
 *  3. Editor Konva: subir/diseñar → confirmar (guías, DPI en vivo)
 *  4. Exporta PNG al DPI objetivo + thumbnail, sube arte + originales a R2
 *     vía el worker de presign (POST /presign → PUT uploadUrl)
 *  5. POST /cart/add.js real con line item properties y redirige a /cart
 *
 * Vanilla JS, sin build step. Konva 9 self-hosted (assets/konva.min.js, defer
 * antes de este archivo).
 */
(function () {
  'use strict';

  var ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  var MAX_EXPORT_DIM = 8000; // px — límite seguro de canvas en móviles

  var FONTS = [
    { name: 'Montserrat (marca)', value: 'Montserrat, sans-serif' },
    { name: 'Arial', value: 'Arial, sans-serif' },
    { name: 'Georgia', value: 'Georgia, serif' },
    { name: 'Times', value: '"Times New Roman", serif' },
    { name: 'Courier', value: '"Courier New", monospace' },
    { name: 'Verdana', value: 'Verdana, sans-serif' },
    { name: 'Impact', value: 'Impact, sans-serif' },
    { name: 'Comic Sans', value: '"Comic Sans MS", cursive' }
  ];

  var SWATCHES = [
    '#031f56', '#1e3a5f', '#ff4f33', '#dbeafe',
    '#000000', '#ffffff', '#ef4444', '#f59e0b',
    '#22c55e', '#3b82f6', '#8b5cf6', '#ec4899'
  ];

  function init(root) {
    if (!root || root.dataset.cveInit === 'true') return;
    root.dataset.cveInit = 'true';

    // ── Config ──────────────────────────────────────────────
    var params = new URLSearchParams(window.location.search);
    var cfg = {
      presignEndpoint: root.dataset.presignEndpoint || 'https://api.gigaprint.com/presign',
      maxSizeMb: parseFloat(root.dataset.maxSizeMb) || 25,
      printW: parseFloat(params.get('pw')) || parseFloat(root.dataset.defaultPrintWidthMm) || 200,
      printH: parseFloat(params.get('ph')) || parseFloat(root.dataset.defaultPrintHeightMm) || 100,
      bleed: firstNumber(params.get('bleed'), root.dataset.defaultBleedMm, 3),
      safe: firstNumber(params.get('safe'), root.dataset.defaultSafeMm, 3),
      targetDpi: parseFloat(root.dataset.targetDpi) || 300,
      minDpi: parseFloat(root.dataset.minDpi) || 150,
      currency: root.dataset.currency || 'MXN',
      handle: params.get('product_handle') || '',
      variantId: params.get('variant_id') || ''
    };

    function firstNumber() {
      for (var i = 0; i < arguments.length; i++) {
        var n = parseFloat(arguments[i]);
        if (!isNaN(n) && n >= 0) return n;
      }
      return 0;
    }

    // ── Referencias DOM ─────────────────────────────────────
    function q(sel) { return root.querySelector(sel); }
    var el = {
      loading: q('[data-cve-loading]'),
      empty: q('[data-cve-empty]'),
      emptyTitle: q('[data-cve-empty-title]'),
      emptyText: q('[data-cve-empty-text]'),
      layout: q('[data-cve-layout]'),
      steps: root.querySelectorAll('[data-cve-steps] .cve-step'),
      panels: root.querySelectorAll('[data-cve-panel]'),
      dropzone: q('[data-cve-dropzone]'),
      file: q('[data-cve-file]'),
      blank: q('[data-cve-blank]'),
      fileAdd: q('[data-cve-file-add]'),
      addImage: q('[data-cve-add-image]'),
      addText: q('[data-cve-add-text]'),
      addShapes: root.querySelectorAll('[data-cve-add-shape]'),
      stageEl: q('[data-cve-stage]'),
      quality: q('[data-cve-quality]'),
      qualityText: q('[data-cve-quality-text]'),
      ctx: q('[data-cve-ctx]'),
      ctxText: q('[data-cve-ctx-text]'),
      ctxColor: q('[data-cve-ctx-color]'),
      ctxImage: q('[data-cve-ctx-image]'),
      textInput: q('[data-cve-text-input]'),
      fontSelect: q('[data-cve-font]'),
      fontSize: q('[data-cve-font-size]'),
      bold: q('[data-cve-bold]'),
      italic: q('[data-cve-italic]'),
      aligns: root.querySelectorAll('[data-cve-align]'),
      swatches: q('[data-cve-swatches]'),
      colorCustom: q('[data-cve-color-custom]'),
      fit: q('[data-cve-fit]'),
      center: q('[data-cve-center]'),
      rotate: q('[data-cve-rotate]'),
      duplicate: q('[data-cve-duplicate]'),
      forward: q('[data-cve-forward]'),
      backward: q('[data-cve-backward]'),
      del: q('[data-cve-delete]'),
      preview: q('[data-cve-preview]'),
      summaryDpi: q('[data-cve-summary-dpi]'),
      progress: q('[data-cve-progress]'),
      progressBar: q('[data-cve-progress-bar]'),
      progressText: q('[data-cve-progress-text]'),
      back: q('[data-cve-back]'),
      next: q('[data-cve-next]'),
      alert: q('[data-cve-alert]'),
      alertText: q('[data-cve-alert-text]'),
      productImage: q('[data-cve-product-image]'),
      productTitle: q('[data-cve-product-title]'),
      productPrice: q('[data-cve-product-price]'),
      variantField: q('[data-cve-variant-field]'),
      variantSelect: q('[data-cve-variant-select]'),
      qty: q('[data-cve-qty]'),
      addToCart: q('[data-cve-add-to-cart]'),
      addLabel: q('[data-cve-add-label]'),
      addSpinner: q('[data-cve-add-spinner]'),
      backToProduct: q('[data-cve-back-to-product]')
    };

    // ── Estado ──────────────────────────────────────────────
    var state = {
      product: null,
      variant: null,
      step: 1,
      busy: false,
      stage: null,
      mainLayer: null,   // elementos del diseño (con clip al área)
      guideLayer: null,
      trLayer: null,
      transformer: null,
      selected: null,
      pxPerMm: 0,
      offset: { x: 0, y: 0 }, // origen del área con sangrado en el stage
      lastDpi: 0
    };

    var moneyFmt = new Intl.NumberFormat('es-MX', { style: 'currency', currency: cfg.currency });
    var bleedW = cfg.printW + cfg.bleed * 2; // mm
    var bleedH = cfg.printH + cfg.bleed * 2; // mm

    // ── Arranque: hidratar producto ─────────────────────────
    if (!cfg.handle) {
      showEmpty();
      return;
    }

    fetch('/products/' + encodeURIComponent(cfg.handle) + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('not-found');
        return res.json();
      })
      .then(function (product) {
        state.product = product;
        hydrateProduct(product);
        el.loading.hidden = true;
        el.layout.hidden = false;
      })
      .catch(function () {
        showEmpty(
          'No encontramos el producto',
          'El enlace puede estar incompleto o el producto ya no está disponible. Vuelve al catálogo e inténtalo de nuevo.'
        );
      });

    function showEmpty(title, text) {
      el.loading.hidden = true;
      el.layout.hidden = true;
      el.empty.hidden = false;
      if (title) el.emptyTitle.textContent = title;
      if (text) el.emptyText.textContent = text;
    }

    function hydrateProduct(product) {
      var img = product.featured_image || (product.images && product.images[0]) || '';
      if (img) {
        el.productImage.src = img;
        el.productImage.alt = product.title;
        el.productImage.hidden = false;
      }
      el.productTitle.textContent = product.title;
      el.backToProduct.href = '/products/' + product.handle;
      el.backToProduct.hidden = false;

      var variants = product.variants || [];
      state.variant = variants.filter(function (v) {
        return String(v.id) === String(cfg.variantId);
      })[0] || variants.filter(function (v) { return v.available; })[0] || variants[0];

      if (variants.length > 1) {
        el.variantSelect.innerHTML = '';
        variants.forEach(function (v) {
          var opt = document.createElement('option');
          opt.value = v.id;
          opt.textContent = v.title + ' — ' + moneyFmt.format(v.price / 100) + (v.available ? '' : ' (agotado)');
          opt.disabled = !v.available;
          if (state.variant && v.id === state.variant.id) opt.selected = true;
          el.variantSelect.appendChild(opt);
        });
        el.variantField.hidden = false;
        el.variantSelect.addEventListener('change', function () {
          state.variant = variants.filter(function (v) {
            return String(v.id) === el.variantSelect.value;
          })[0] || state.variant;
          renderPrice();
        });
      }
      renderPrice();
    }

    function renderPrice() {
      if (!state.variant) return;
      el.productPrice.textContent = moneyFmt.format(state.variant.price / 100);
      el.backToProduct.href = '/products/' + state.product.handle + '?variant=' + state.variant.id;
    }

    // ── Stepper ─────────────────────────────────────────────
    function hasElements() {
      return !!(state.mainLayer && state.mainLayer.children.length > 0);
    }

    function goToStep(n) {
      state.step = n;
      el.steps.forEach(function (s) {
        var num = parseInt(s.dataset.step, 10);
        s.classList.toggle('is-active', num === n);
        s.classList.toggle('is-done', num < n);
      });
      el.panels.forEach(function (p) {
        p.classList.toggle('is-active', parseInt(p.dataset.cvePanel, 10) === n);
      });
      el.back.hidden = n === 1;
      el.next.hidden = n === 3;
      updateNextState();
      el.addToCart.disabled = n !== 3 || state.busy;
      hideAlert();
    }

    function updateNextState() {
      el.next.disabled = !hasElements();
    }

    el.back.addEventListener('click', function () {
      if (state.step > 1 && !state.busy) goToStep(state.step - 1);
    });

    el.next.addEventListener('click', function () {
      if (state.busy || !hasElements()) return;
      if (state.step === 1) {
        goToStep(2);
        ensureStage();
      } else if (state.step === 2) {
        select(null);
        buildPreview();
        goToStep(3);
      }
    });

    // ── Paso 1 · Subida inicial o lienzo en blanco ──────────
    el.dropzone.addEventListener('dragover', function (e) {
      e.preventDefault();
      el.dropzone.classList.add('is-dragover');
    });
    el.dropzone.addEventListener('dragleave', function () {
      el.dropzone.classList.remove('is-dragover');
    });
    el.dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      el.dropzone.classList.remove('is-dragover');
      if (e.dataTransfer.files && e.dataTransfer.files[0]) loadImageFile(e.dataTransfer.files[0], true);
    });
    el.file.addEventListener('change', function () {
      if (el.file.files && el.file.files[0]) loadImageFile(el.file.files[0], true);
      el.file.value = '';
    });
    el.blank.addEventListener('click', function () {
      goToStep(2);
      ensureStage();
    });

    function loadImageFile(file, coverArea) {
      hideAlert();
      if (ACCEPTED_TYPES.indexOf(file.type) === -1) {
        showAlert('Formato no permitido. Usa JPG, PNG o WebP.');
        return;
      }
      if (file.size > cfg.maxSizeMb * 1024 * 1024) {
        showAlert('El archivo pesa más de ' + cfg.maxSizeMb + ' MB. Comprímelo o escríbenos por WhatsApp.');
        return;
      }
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        goToStep(2);
        ensureStage();
        addImageNode(img, file, coverArea);
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        showAlert('No pudimos leer la imagen. Intenta con otro archivo.');
      };
      img.src = url;
    }

    // ── Stage Konva (se construye una sola vez) ─────────────
    function ensureStage() {
      if (state.stage) return;
      if (!window.Konva) {
        showAlert('El editor no cargó correctamente. Recarga la página e inténtalo de nuevo.');
        return;
      }

      var margin = 28;
      var wrapW = el.stageEl.clientWidth || 640;
      var maxH = Math.min(window.innerHeight * 0.6, 560);
      var scaleX = (wrapW - margin * 2) / bleedW;
      var scaleY = (maxH - margin * 2) / bleedH;
      state.pxPerMm = Math.max(Math.min(scaleX, scaleY), 0.05);

      var stageW = wrapW;
      var stageH = Math.round(bleedH * state.pxPerMm + margin * 2);
      state.offset = {
        x: Math.round((stageW - bleedW * state.pxPerMm) / 2),
        y: margin
      };

      var stage = new Konva.Stage({ container: el.stageEl, width: stageW, height: stageH });
      state.stage = stage;

      var mm = function (v) { return v * state.pxPerMm; };
      var off = state.offset;

      // Papel (área con sangrado)
      var bgLayer = new Konva.Layer({ listening: false });
      bgLayer.add(new Konva.Rect({
        x: off.x, y: off.y, width: mm(bleedW), height: mm(bleedH),
        fill: '#ffffff', shadowColor: 'rgba(15,23,42,0.25)', shadowBlur: 14, shadowOffsetY: 3
      }));
      stage.add(bgLayer);

      // Capa de elementos, con clip al área
      var mainLayer = new Konva.Layer({
        clipX: off.x, clipY: off.y, clipWidth: mm(bleedW), clipHeight: mm(bleedH)
      });
      state.mainLayer = mainLayer;
      stage.add(mainLayer);

      // Guías: recorte (rojo) y área segura (punteada)
      var guideLayer = new Konva.Layer({ listening: false });
      state.guideLayer = guideLayer;
      guideLayer.add(new Konva.Rect({
        x: off.x + mm(cfg.bleed), y: off.y + mm(cfg.bleed),
        width: mm(cfg.printW), height: mm(cfg.printH),
        stroke: '#dc2626', strokeWidth: 1.5
      }));
      guideLayer.add(new Konva.Rect({
        x: off.x + mm(cfg.bleed + cfg.safe), y: off.y + mm(cfg.bleed + cfg.safe),
        width: mm(cfg.printW - cfg.safe * 2), height: mm(cfg.printH - cfg.safe * 2),
        stroke: '#0ea5e9', strokeWidth: 1, dash: [6, 4]
      }));
      stage.add(guideLayer);

      // Transformer en capa propia SIN clip (anclas siempre visibles)
      var trLayer = new Konva.Layer();
      state.trLayer = trLayer;
      stage.add(trLayer);

      var tr = new Konva.Transformer({
        rotateEnabled: true,
        anchorSize: 12,
        anchorCornerRadius: 6,
        anchorStroke: '#031f56',
        borderStroke: '#031f56',
        borderDash: [4, 4],
        boundBoxFunc: function (oldBox, newBox) {
          if (Math.abs(newBox.width) < 18 || Math.abs(newBox.height) < 18) return oldBox;
          return newBox;
        }
      });
      trLayer.add(tr);
      state.transformer = tr;

      // Selección: click en elemento selecciona; click fuera deselecciona
      stage.on('mousedown touchstart', function (e) {
        if (e.target === stage) { select(null); return; }
        var node = e.target;
        if (node.getLayer() === mainLayer) select(node);
      });

      // Doble click en texto → enfocar el editor de texto
      stage.on('dblclick dbltap', function (e) {
        if (e.target.getClassName && e.target.getClassName() === 'Text') {
          select(e.target);
          el.textInput.focus();
          el.textInput.select();
        }
      });
    }

    // ── Crear elementos ─────────────────────────────────────
    var mmToPx = function (v) { return v * state.pxPerMm; };

    function areaCenter() {
      return {
        x: state.offset.x + mmToPx(bleedW) / 2,
        y: state.offset.y + mmToPx(bleedH) / 2
      };
    }

    function registerNode(node) {
      state.mainLayer.add(node);
      node.on('dragmove transform', updateQuality);
      if (node.getClassName() === 'Text') {
        // Al escalar texto, hornear la escala en fontSize para mantenerlo nítido
        node.on('transformend', function () {
          var s = Math.abs(node.scaleY());
          if (s !== 1) {
            node.fontSize(node.fontSize() * s);
            node.width(node.width() * Math.abs(node.scaleX()));
            node.scaleX(1);
            node.scaleY(1);
          }
          syncCtx();
        });
      }
      select(node);
      updateQuality();
      updateNextState();
    }

    function addImageNode(imgEl, file, coverArea) {
      var nw = imgEl.naturalWidth, nh = imgEl.naturalHeight;
      var bw = mmToPx(bleedW), bh = mmToPx(bleedH);
      var scale = coverArea
        ? Math.max(bw / nw, bh / nh)          // cubre el área (arte principal)
        : Math.min(bw / nw, bh / nh) * 0.6;   // elemento adicional, más chico
      var c = areaCenter();
      var node = new Konva.Image({
        image: imgEl,
        width: nw, height: nh,
        offsetX: nw / 2, offsetY: nh / 2,
        x: c.x, y: c.y,
        scaleX: scale, scaleY: scale,
        draggable: true
      });
      node.setAttr('gpKind', 'image');
      node.setAttr('gpFile', file);
      registerNode(node);
    }

    function addTextNode() {
      var c = areaCenter();
      var node = new Konva.Text({
        text: 'Tu texto aquí',
        fontFamily: FONTS[0].value,
        fontSize: Math.max(mmToPx(Math.min(cfg.printH, cfg.printW) / 6), 14),
        fill: '#031f56',
        align: 'center',
        width: mmToPx(cfg.printW * 0.8),
        draggable: true
      });
      node.offsetX(node.width() / 2);
      node.offsetY(node.height() / 2);
      node.position(c);
      node.setAttr('gpKind', 'text');
      registerNode(node);
      el.textInput.focus();
      el.textInput.select();
    }

    function addShapeNode(kind) {
      var c = areaCenter();
      var base = mmToPx(Math.min(cfg.printW, cfg.printH)) * 0.45;
      var node;
      if (kind === 'rect') {
        node = new Konva.Rect({
          width: base * 1.4, height: base,
          offsetX: (base * 1.4) / 2, offsetY: base / 2,
          x: c.x, y: c.y, fill: '#031f56', draggable: true, cornerRadius: 2
        });
      } else if (kind === 'circle') {
        node = new Konva.Circle({ radius: base / 2, x: c.x, y: c.y, fill: '#031f56', draggable: true });
      } else {
        node = new Konva.Star({
          numPoints: 5, innerRadius: base / 4, outerRadius: base / 2,
          x: c.x, y: c.y, fill: '#031f56', draggable: true
        });
      }
      node.setAttr('gpKind', 'shape');
      registerNode(node);
    }

    el.addImage.addEventListener('click', function () { el.fileAdd.click(); });
    el.fileAdd.addEventListener('change', function () {
      if (el.fileAdd.files && el.fileAdd.files[0]) loadImageFile(el.fileAdd.files[0], false);
      el.fileAdd.value = '';
    });
    el.addText.addEventListener('click', addTextNode);
    el.addShapes.forEach(function (btn) {
      btn.addEventListener('click', function () { addShapeNode(btn.dataset.cveAddShape); });
    });

    // ── Selección y panel contextual ────────────────────────
    function select(node) {
      state.selected = node || null;
      if (!state.transformer) return;
      if (node) {
        var isText = node.getClassName() === 'Text';
        var isImage = node.getClassName() === 'Image';
        state.transformer.setAttrs({
          enabledAnchors: isText || isImage
            ? ['top-left', 'top-right', 'bottom-left', 'bottom-right']
            : ['top-left', 'top-center', 'top-right', 'middle-left', 'middle-right', 'bottom-left', 'bottom-center', 'bottom-right'],
          keepRatio: isText || isImage
        });
        state.transformer.nodes([node]);
      } else {
        state.transformer.nodes([]);
      }
      syncCtx();
    }

    function syncCtx() {
      var node = state.selected;
      if (!node) {
        el.ctx.hidden = true;
        return;
      }
      el.ctx.hidden = false;
      var kind = node.getAttr('gpKind');
      el.ctxText.hidden = kind !== 'text';
      el.ctxColor.hidden = kind === 'image';
      el.ctxImage.hidden = kind !== 'image';

      if (kind === 'text') {
        if (document.activeElement !== el.textInput) el.textInput.value = node.text();
        el.fontSelect.value = node.fontFamily();
        el.fontSize.value = Math.round(node.fontSize() / state.pxPerMm); // mm
        var style = node.fontStyle() || 'normal';
        el.bold.classList.toggle('is-on', style.indexOf('bold') !== -1);
        el.italic.classList.toggle('is-on', style.indexOf('italic') !== -1);
        el.aligns.forEach(function (b) {
          b.classList.toggle('is-on', b.dataset.cveAlign === node.align());
        });
      }
      if (kind !== 'image') {
        var fill = node.fill();
        el.swatches.querySelectorAll('.cve-swatch').forEach(function (s) {
          s.classList.toggle('is-on', s.dataset.color === fill);
        });
      }
    }

    // Poblar selector de fuentes y swatches
    FONTS.forEach(function (f) {
      var opt = document.createElement('option');
      opt.value = f.value;
      opt.textContent = f.name;
      opt.style.fontFamily = f.value;
      el.fontSelect.appendChild(opt);
    });
    SWATCHES.forEach(function (color) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cve-swatch';
      b.dataset.color = color;
      b.style.background = color;
      b.setAttribute('aria-label', 'Color ' + color);
      if (color === '#ffffff') b.style.borderColor = '#cbd5e1';
      b.addEventListener('click', function () { applyFill(color); });
      el.swatches.appendChild(b);
    });
    el.colorCustom.addEventListener('input', function () { applyFill(el.colorCustom.value); });

    function applyFill(color) {
      var node = state.selected;
      if (!node || node.getAttr('gpKind') === 'image') return;
      node.fill(color);
      syncCtx();
    }

    // Controles de texto
    el.textInput.addEventListener('input', function () {
      var node = state.selected;
      if (node && node.getAttr('gpKind') === 'text') node.text(el.textInput.value || ' ');
    });
    el.fontSelect.addEventListener('change', function () {
      var node = state.selected;
      if (node && node.getAttr('gpKind') === 'text') node.fontFamily(el.fontSelect.value);
    });
    el.fontSize.addEventListener('change', function () {
      var node = state.selected;
      var v = parseFloat(el.fontSize.value);
      if (node && node.getAttr('gpKind') === 'text' && v > 0) node.fontSize(mmToPx(v));
    });
    function toggleStyle(which) {
      var node = state.selected;
      if (!node || node.getAttr('gpKind') !== 'text') return;
      var parts = (node.fontStyle() || 'normal').split(' ').filter(function (p) { return p !== 'normal' && p; });
      var idx = parts.indexOf(which);
      if (idx === -1) parts.push(which); else parts.splice(idx, 1);
      node.fontStyle(parts.length ? parts.join(' ') : 'normal');
      syncCtx();
    }
    el.bold.addEventListener('click', function () { toggleStyle('bold'); });
    el.italic.addEventListener('click', function () { toggleStyle('italic'); });
    el.aligns.forEach(function (b) {
      b.addEventListener('click', function () {
        var node = state.selected;
        if (node && node.getAttr('gpKind') === 'text') {
          node.align(b.dataset.cveAlign);
          syncCtx();
        }
      });
    });

    // ── Acciones comunes ────────────────────────────────────
    function recenterTo(node, cx, cy) {
      var rect = node.getClientRect();
      node.x(node.x() + (cx - (rect.x + rect.width / 2)));
      node.y(node.y() + (cy - (rect.y + rect.height / 2)));
    }

    el.fit.addEventListener('click', function () {
      var node = state.selected;
      if (!node || node.getAttr('gpKind') !== 'image') return;
      var nw = node.width(), nh = node.height();
      var scale = Math.max(mmToPx(bleedW) / nw, mmToPx(bleedH) / nh);
      var c = areaCenter();
      node.setAttrs({ rotation: 0, scaleX: scale, scaleY: scale, x: c.x, y: c.y });
      updateQuality();
    });

    el.center.addEventListener('click', function () {
      var node = state.selected;
      if (!node) return;
      var c = areaCenter();
      recenterTo(node, c.x, c.y);
    });

    el.rotate.addEventListener('click', function () {
      var node = state.selected;
      if (!node) return;
      var rect = node.getClientRect();
      var cx = rect.x + rect.width / 2, cy = rect.y + rect.height / 2;
      node.rotation((node.rotation() + 90) % 360);
      recenterTo(node, cx, cy);
      updateQuality();
    });

    el.duplicate.addEventListener('click', function () {
      var node = state.selected;
      if (!node) return;
      var clone = node.clone({ x: node.x() + 14, y: node.y() + 14 });
      state.mainLayer.add(clone);
      select(clone);
      updateQuality();
      updateNextState();
    });

    el.forward.addEventListener('click', function () {
      if (state.selected) state.selected.moveUp();
    });
    el.backward.addEventListener('click', function () {
      if (state.selected) state.selected.moveDown();
    });

    function deleteSelected() {
      var node = state.selected;
      if (!node) return;
      select(null);
      node.destroy();
      updateQuality();
      updateNextState();
    }
    el.del.addEventListener('click', deleteSelected);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Delete' && e.key !== 'Backspace') return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if (state.step === 2 && state.selected) {
        e.preventDefault();
        deleteSelected();
      }
    });

    // ── Calidad / DPI (sobre las imágenes) ──────────────────
    function worstImageDpi() {
      if (!state.mainLayer) return 0;
      var worst = 0;
      state.mainLayer.children.forEach(function (node) {
        if (node.getAttr('gpKind') !== 'image') return;
        var imgEl = node.image();
        var shownWmm = (node.width() * Math.abs(node.scaleX())) / state.pxPerMm;
        var dpi = Math.floor(imgEl.naturalWidth / (shownWmm / 25.4));
        if (!worst || dpi < worst) worst = dpi;
      });
      return worst;
    }

    function updateQuality() {
      var dpi = worstImageDpi();
      state.lastDpi = dpi;
      if (!dpi) {
        el.quality.hidden = true;
        return;
      }
      el.quality.hidden = false;
      var cls = dpi >= cfg.targetDpi ? 'is-good' : dpi >= cfg.minDpi ? 'is-warn' : 'is-bad';
      var label = dpi >= cfg.targetDpi
        ? 'Excelente calidad · ' + dpi + ' DPI'
        : dpi >= cfg.minDpi
          ? 'Calidad aceptable · ' + dpi + ' DPI'
          : 'Baja resolución · ' + dpi + ' DPI';
      el.quality.classList.remove('is-good', 'is-warn', 'is-bad');
      el.quality.classList.add(cls);
      el.qualityText.textContent = label;
    }

    // ── Paso 3 · Preview + export ───────────────────────────
    function withGuidesHidden(fn) {
      state.guideLayer.visible(false);
      state.trLayer.visible(false);
      try {
        return fn();
      } finally {
        state.guideLayer.visible(true);
        state.trLayer.visible(true);
      }
    }

    function exportRegion() {
      return {
        x: state.offset.x,
        y: state.offset.y,
        width: mmToPx(bleedW),
        height: mmToPx(bleedH)
      };
    }

    function buildPreview() {
      if (!state.stage) return;
      var region = exportRegion();
      var ratio = Math.min(600 / region.width, 600 / region.height, 4);
      var dataUrl = withGuidesHidden(function () {
        return state.stage.toDataURL({
          x: region.x, y: region.y, width: region.width, height: region.height,
          pixelRatio: ratio, mimeType: 'image/png'
        });
      });
      el.preview.src = dataUrl;
      el.preview.hidden = false;

      var dpi = state.lastDpi;
      el.summaryDpi.classList.remove('is-good', 'is-warn', 'is-bad');
      if (dpi) {
        var cls = dpi >= cfg.targetDpi ? 'is-good' : dpi >= cfg.minDpi ? 'is-warn' : 'is-bad';
        el.summaryDpi.classList.add(cls);
        el.summaryDpi.textContent = 'Resolución efectiva: ' + dpi + ' DPI' +
          (dpi < cfg.minDpi ? ' — la impresión puede verse pixelada.' : '');
        el.summaryDpi.hidden = false;
      } else {
        el.summaryDpi.classList.add('is-good');
        el.summaryDpi.textContent = 'Diseño vectorial: se imprime nítido a cualquier tamaño.';
        el.summaryDpi.hidden = false;
      }
    }

    function exportArtworkBlob() {
      return new Promise(function (resolve, reject) {
        var region = exportRegion();
        var exportPxPerMm = cfg.targetDpi / 25.4;
        var ratio = exportPxPerMm / state.pxPerMm;
        var maxRatio = MAX_EXPORT_DIM / Math.max(region.width, region.height);
        if (ratio > maxRatio) ratio = maxRatio;

        withGuidesHidden(function () {
          state.stage.toBlob({
            x: region.x, y: region.y, width: region.width, height: region.height,
            pixelRatio: ratio,
            mimeType: 'image/png',
            callback: function (blob) {
              if (blob) resolve(blob);
              else reject(new Error('export-failed'));
            }
          });
        });
      });
    }

    function dataUrlToBlob(dataUrl) {
      var parts = dataUrl.split(',');
      var mime = parts[0].match(/:(.*?);/)[1];
      var bin = atob(parts[1]);
      var arr = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
      return new Blob([arr], { type: mime });
    }

    // ── Subida a R2 (contrato del worker de presign) ────────
    function uploadToR2(blob, filename) {
      return fetch(cfg.presignEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: filename, contentType: blob.type, size: blob.size })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('presign-failed');
          return res.json();
        })
        .then(function (data) {
          return fetch(data.uploadUrl, { method: 'PUT', body: blob }).then(function (res) {
            if (!res.ok) throw new Error('upload-failed');
            return data.publicUrl;
          });
        });
    }

    function setProgress(pct, text) {
      el.progress.hidden = false;
      el.progressBar.style.width = pct + '%';
      if (text) el.progressText.textContent = text;
    }

    // ── Agregar al carrito ──────────────────────────────────
    el.addToCart.addEventListener('click', function () {
      if (state.busy || !state.variant || !hasElements()) return;
      state.busy = true;
      hideAlert();
      el.addToCart.disabled = true;
      el.addSpinner.hidden = false;
      el.addLabel.textContent = 'Guardando diseño…';

      var stamp = Date.now();
      var base = (state.product.handle || 'diseno') + '-' + stamp;
      var qty = Math.max(parseInt(el.qty.value, 10) || 1, 1);
      var artworkUrl, previewUrl;
      var fileUrls = new Map(); // File → publicUrl (originales de cada imagen)

      var fontsReady = document.fonts && document.fonts.ready
        ? document.fonts.ready.catch(function () {})
        : Promise.resolve();

      setProgress(6, 'Exportando tu arte en alta resolución…');

      fontsReady
        .then(exportArtworkBlob)
        .then(function (artBlob) {
          setProgress(22, 'Subiendo arte final…');
          return uploadToR2(artBlob, base + '-print.png');
        })
        .then(function (url) {
          artworkUrl = url;
          setProgress(45, 'Subiendo vista previa…');
          return uploadToR2(dataUrlToBlob(el.preview.src), base + '-preview.png');
        })
        .then(function (url) {
          previewUrl = url;
          // Subir el original de cada imagen usada (secuencial)
          var files = [];
          state.mainLayer.children.forEach(function (node) {
            var f = node.getAttr('gpFile');
            if (f && files.indexOf(f) === -1) files.push(f);
          });
          var chain = Promise.resolve();
          files.forEach(function (f, i) {
            chain = chain.then(function () {
              setProgress(55 + Math.round((i / Math.max(files.length, 1)) * 25),
                'Subiendo original ' + (i + 1) + ' de ' + files.length + '…');
              return uploadToR2(f, base + '-original-' + (i + 1) + '-' + sanitize(f.name))
                .then(function (u) { fileUrls.set(f, u); });
            });
          });
          return chain;
        })
        .then(function () {
          setProgress(86, 'Agregando al carrito…');
          var firstSource = '';
          fileUrls.forEach(function (u) { if (!firstSource) firstSource = u; });
          var props = {
            '_artwork_url': artworkUrl,
            '_design_state': designState(fileUrls),
            'Vista previa': previewUrl
          };
          if (firstSource) props['_source_url'] = firstSource;
          if (state.lastDpi) props['_print_dpi'] = String(state.lastDpi);
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: state.variant.id, quantity: qty, properties: props }] })
          });
        })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err.description || err.message || 'cart-failed');
            });
          }
          setProgress(100, '¡Listo! Redirigiendo al carrito…');
          window.location.href = '/cart';
        })
        .catch(function (err) {
          state.busy = false;
          el.addToCart.disabled = false;
          el.addSpinner.hidden = true;
          el.addLabel.textContent = 'Reintentar';
          el.progress.hidden = true;
          var msg = err && err.message === 'presign-failed'
            ? 'No pudimos conectar con el servidor de archivos. Revisa tu conexión e inténtalo de nuevo.'
            : err && err.message === 'upload-failed'
              ? 'La subida del diseño falló. Inténtalo de nuevo.'
              : 'No pudimos agregar el producto al carrito. ' + (err && err.message ? err.message : '');
          showAlert(msg);
        });
    });

    // Estado compacto del diseño (mm, relativo al área con sangrado) — permite
    // re-edición futura sin exceder el límite de las line item properties
    function designState(fileUrls) {
      var px = state.pxPerMm;
      var off = state.offset;
      var elements = [];
      state.mainLayer.children.forEach(function (node) {
        var kind = node.getAttr('gpKind');
        var e = {
          t: kind === 'image' ? 'img' : node.getClassName().toLowerCase(),
          x: round2((node.x() - off.x) / px),
          y: round2((node.y() - off.y) / px),
          r: round2(node.rotation())
        };
        if (kind === 'image') {
          var f = node.getAttr('gpFile');
          e.src = (f && fileUrls.get(f)) || '';
          e.w = round2((node.width() * Math.abs(node.scaleX())) / px);
        } else if (kind === 'text') {
          e.text = node.text();
          e.font = node.fontFamily();
          e.size = round2(node.fontSize() / px);
          e.style = node.fontStyle() || 'normal';
          e.fill = node.fill();
          e.align = node.align();
          e.w = round2((node.width() * Math.abs(node.scaleX())) / px);
        } else {
          e.fill = node.fill();
          var rect = node.getClientRect();
          e.w = round2(rect.width / px);
          e.h = round2(rect.height / px);
        }
        elements.push(e);
      });
      return JSON.stringify({
        v: 2,
        print: { w: cfg.printW, h: cfg.printH, bleed: cfg.bleed, safe: cfg.safe },
        els: elements
      });
    }

    function round2(n) { return Math.round(n * 100) / 100; }
    function sanitize(name) {
      return String(name).replace(/[\\/]/g, '').replace(/[^a-zA-Z0-9._-]/g, '_').toLowerCase().slice(0, 80);
    }

    // ── Alertas ─────────────────────────────────────────────
    var alertTimer;
    function showAlert(msg) {
      el.alertText.textContent = msg;
      el.alert.hidden = false;
      el.alert.classList.add('cve-alert--shake');
      clearTimeout(alertTimer);
      alertTimer = setTimeout(function () {
        el.alert.classList.remove('cve-alert--shake');
      }, 600);
      el.alert.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    function hideAlert() {
      el.alert.hidden = true;
    }
  }

  function boot() {
    document.querySelectorAll('[data-canvas-editor]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor de Shopify: re-inicializa al recargar la sección
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-canvas-editor]');
    if (root) {
      delete root.dataset.cveInit;
      init(root);
    }
  });
})();
